import { useEffect, useMemo, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';

import EmptyOnlineOrdersHistory from './EmptyOnlineOrdersHistory';
import OnlineOrderHistoryOverview from './OnlineOrderHistoryOverview';

import LoaderTable from '@loaders/LoaderTable';

import { OnlinerOrderHistoryPayload } from '@interfaces/myPurchasesInterfaces';

import { getOnlineOrdersHistory, getRetailOrderHistory } from '@services/myPurchasesServices';
import { getCookie } from '@utils/cookie';
import * as actions from '@redux-actions/';
import _ from 'lodash';
import { getPersonalDetails } from '@services/myProfileServices';


const OnlineOrderHistory = (): JSX.Element => {
    const config = useSelector((state: RootState) => state.common.config);
    const onlineOrdersHistory = useSelector((state: RootState) => state.myPurchases.onlineOrders);
    const retailOrderHistory = useSelector((state: RootState) => state.myPurchases.retailOrders);
    const [eventPushed, setEventPushed] = useState(false);
    const personalDetails = useSelector((state: RootState) => state.myProfile.personalDetails);

    const onlineOrdersRequestStatus = useSelector(
        (state: RootState) => state.myPurchases.onlineOrdersRequestStatus
    );

    const retailOrderRequestStatus = useSelector(
        (state: RootState) => state.myPurchases.retailOrdersRequestStatus
    )

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getPersonalDetails(config.mockRequest, config.storeId));
    }, []);

    const eMail = useMemo(() => {
        const email = getCookie('email_address');
        return personalDetails?.email || email;
    }, [personalDetails?.email]);

    useEffect(() => {
        const payload: OnlinerOrderHistoryPayload = {
            isMockRequest: config.mockRequest,
            storeId: config.storeId,
            currency: config.currencyCode,
            pageNumber: 1,
            pageSize: 50,
        };

        if (onlineOrdersHistory.length === 0) {
            dispatch(getOnlineOrdersHistory(payload));
        }

        if (retailOrderHistory.length === 0) {
            dispatch(getRetailOrderHistory(config.mockRequest, config.storeId, eMail))
        }
    }, []);

    const switchForDevice = (value) => {
        switch (value) {
            case 'desktop':
                return 'D';
            case 'mobile':
                return 'M';
            case 'tablet':
                return 'T';
            case 'responsive':
                return 'X';
            case 'ipad':
                return 'iPAD';
            default:
                return value;
        }
    }

    useEffect(() => {
        let containsEcomOrders = ''
        let containsInStoreOrders = ''
        var containsContact = false;
        var containsFrames = false;
        var containsSun = false;
        var userOrderHistorySource = ""
        var userOrderHistoryProdsCategory = ""

        if (!!retailOrderHistory) {
            retailOrderHistory.map(orderRetailInformation => {
                if (orderRetailInformation.retailOrderDetails.hasContactLenses) {
                    containsContact = true;
                }

                if (orderRetailInformation.retailOrderDetails.orderItems.filter(element => element.productKind === "SUN").length > 0) {
                    containsSun = true;
                }

                if (orderRetailInformation.retailOrderDetails.orderItems.filter(element => element.productKind === "FRAMES").length > 0) {
                    containsFrames = true;
                }
            })
        }

        if (!!onlineOrdersHistory) {
            onlineOrdersHistory.map(orderOnlineInformation => {
                if (orderOnlineInformation.hasContactLenses === "true") {
                    containsContact = true;
                }

                if (orderOnlineInformation.orderFormedBy.includes('SUN')) {
                    containsSun = true;
                }

                if (orderOnlineInformation.orderFormedBy.includes('EYE')) {
                    containsFrames = true;
                }
            })
        }

        if (containsContact && containsFrames && containsSun) {
            userOrderHistoryProdsCategory = 'CONTACT LENSES, SUN, OPTICS'
        } else {
            if (containsContact && !userOrderHistoryProdsCategory.includes('CONTACT LENSES')) {
                if (userOrderHistoryProdsCategory.length > 0) {
                    userOrderHistoryProdsCategory = userOrderHistoryProdsCategory + ', CONTACT LENSES'
                } else {
                    userOrderHistoryProdsCategory = 'CONTACT LENSES'
                }
            }

            if (containsFrames && !userOrderHistoryProdsCategory.includes('OPTICS')) {
                if (userOrderHistoryProdsCategory.length > 0) {
                    userOrderHistoryProdsCategory = userOrderHistoryProdsCategory + ', OPTICS'
                } else {
                    userOrderHistoryProdsCategory = 'OPTICS'
                }
            }

            if (containsSun && !userOrderHistoryProdsCategory.includes('SUN')) {
                if (userOrderHistoryProdsCategory.length > 0) {
                    userOrderHistoryProdsCategory = userOrderHistoryProdsCategory + ', SUN'
                } else {
                    userOrderHistoryProdsCategory = 'SUN'
                }
            }
        }

        if (onlineOrdersHistory.length > 0 && retailOrderHistory.length > 0) {
            userOrderHistorySource = 'E,S'
        } else {
            if (onlineOrdersHistory.length > 0) {
                userOrderHistorySource = 'E'
            }

            if (retailOrderHistory.length > 0) {
                userOrderHistorySource = 'S'
            }
        }

        if (!eventPushed && onlineOrdersRequestStatus === 'SUCCESS' && retailOrderRequestStatus === 'SUCCESS' /*&& (onlineOrdersHistory?.length > 0 || retailOrderHistory?.length > 0)*/) {
            setEventPushed(true);

            let obj = {
                id: 'VirtualPage-View',
                Page_Type: 'Static',
                Page_Section1: 'Account',
                Page_Section2: '',
                Page_Brand: window.universalTagData.Page_Brand !== undefined ? window.universalTagData.Page_Brand : '',
                Page_Country: window.universalTagData.Page_Country !== undefined ? window.universalTagData.Page_Country : '',
                Page_Platform: window.universalTagData.Page_Platform !== undefined ? window.universalTagData.Page_Platform : '',
                Page_Language: window.universalTagData.Page_Language !== undefined ? window.universalTagData.Page_Language : '',
                Page_DeviceType: window.universalTagData.Page_DeviceType !== undefined ? switchForDevice(window.universalTagData.Page_DeviceType) : '',
                Page_Server: window.universalTagData.Page_Server,
                User_LoginStatus: window.universalTagData.User_LoginStatus !== undefined ? window.universalTagData.User_LoginStatus : '',
                User_LoginType: window.universalTagData.User_LoginType !== undefined ? window.universalTagData.User_LoginType : '',
                User_Email_MD5: window.universalTagData.User_Email_MD5 !== undefined ? window.universalTagData.User_Email_MD5 : '',
                User_Email_SHA256: window.universalTagData.User_Email_SHA256 !== undefined ? window.universalTagData.User_Email_SHA256 : '',
                User_Phone_MD5: window.universalTagData.User_Phone_MD5 !== undefined ? window.universalTagData.User_Phone_MD5 : '',
                User_Phone_SHA256: window.universalTagData.User_Phone_SHA256 !== undefined ? window.universalTagData.User_Phone_SHA256 : '',
                User_EmailOptin: window.universalTagData.User_EmailOptin !== undefined ? window.universalTagData.User_EmailOptin : '0',
                User_Id: window.universalTagData.User_Id.toString(),
                User_Segments: window.universalTagData.User_Segments !== undefined ? window.universalTagData.User_Segments : '',
                Fs_IsConnected: window.universalTagData.Fs_IsConnected !== undefined ? window.universalTagData.Fs_IsConnected : '',
                Page_UserFace: window.universalTagData.Page_UserFace !== undefined ? window.universalTagData.Page_UserFace : '',
                Page_UserStyle: window.universalTagData.Page_UserStyle !== undefined ? window.universalTagData.Page_UserStyle : '',
                User_OrderHistory_Source: userOrderHistorySource !== undefined ? userOrderHistorySource : '',
                User_OrderHistory_ProdsCategory: userOrderHistoryProdsCategory !== undefined ? userOrderHistoryProdsCategory : ''
                //...window.universalTagData //not work with all universalTagData (not push event but modify existing event)
            };
            if (window.universalTagData.User_Country !== undefined && window.universalTagData.User_Country !== 'N.A.' && window.universalTagData.User_Country !== 'UNDEFINED') {
                obj.User_Country = window.universalTagData.User_Country;
            }
            window?.tealium_data2track?.push(obj);
            dispatch(actions.setIsMenuMobileSelected(true));
        }
    }, [onlineOrdersRequestStatus, retailOrderRequestStatus])

    return (
        <div className="online-orders-history">
            {onlineOrdersRequestStatus === 'LOADING' || retailOrderRequestStatus === 'LOADING' && (<LoaderTable />)}
            {(onlineOrdersRequestStatus === 'SUCCESS' && retailOrderRequestStatus === 'SUCCESS') &&
                (onlineOrdersHistory?.length > 0 || retailOrderHistory?.length > 0 ? (
                    onlineOrdersHistory?.length > 0 && retailOrderHistory?.length > 0 ? (
                        <OnlineOrderHistoryOverview onlineOrders={onlineOrdersHistory} retailOrders={retailOrderHistory} />
                    ) : (
                        onlineOrdersHistory?.length > 0 ? (
                            <OnlineOrderHistoryOverview onlineOrders={onlineOrdersHistory} />
                        ) : (
                            <OnlineOrderHistoryOverview retailOrders={retailOrderHistory} />
                        )
                    )
                ) : (
                    <EmptyOnlineOrdersHistory />
                ))}
        </div>
    );
};
export default OnlineOrderHistory;
